<div class="col">
  <div class="row justify-content-center g-4 p-4">
    @for (category of categories; track $index) {
    <div class="col-auto">
      <button 
        type="button" 
        class="btn btn-secondary btn-lg rounded-3" 
        (click)="selectCategory(category)"
        [ngClass]="{'selected': containsCategory(category)}"
      >
        <input class="form-check-input pe-none" type="checkbox" value="" [attr.checked]="containsCategory(category) ? true : null">
        {{ category.name }} 
        <span class="badge text-bg-primary rounded-circle">{{ category.count }}</span>
      </button>
    </div>
    }
  </div>

  <div class="row justify-content-between g-4 p-4">
    <div class="col-auto">
      <h3 class="font-size-36">Upcoming Events</h3>
    </div>
    <div class="col-auto">
      <h3 class="font-size-36">{{events.length}} Events</h3>
    </div>
  </div>

  @if (empty()) {
    <div class="row">
      <div class="col-3 mx-auto">
          <div class="row g-0 my-1">
              <h1 class="text-center">No Upcoming Events</h1>
          </div>
          <div class="row g-0 my-1">
              <span class="text-center font-size-16">Check back later for updates to the training schedule.</span>
          </div>
      </div>
    </div>
  }

  <div class="row row-cols-3 g-4 p-4" >
    @for (event of events; track $index) {
    <div class="col-12 col-md-4"
      *ngIf="!event.unlisted && (containsEvent(event) || selectedCategories.length === 0)"
    >
      <div class="card h-100 border-0">
        @if (event.imgUrls) {
          <ngb-carousel>
            @for (imgUrl of event.imgUrls; track imgUrl) {
              <ng-template ngbSlide>
                <div class="picsum-img-wrapper">
                  <img src="https://cdn.wyvern-weaponry.com/{{ imgUrl }}" class="d-block w-100 crop card-img-top crop rounded-top-4" alt="...">
                </div>
              </ng-template>
            }
          </ngb-carousel>
        }

        <div class="position-absolute mt-3 bg-primary p-1 rounded-3">
          <div class="row justify-content-center p-1 g-1">
            <img class="white-svg col-auto" src="users-solid-full.svg" width="30" height="24" alt="clock"/>
            <div class="font-size-16 text-white col-auto"> {{ event.vacancies }} Seats left </div>
          </div>
        </div>
        
        <div class="card-body">
          <h5 class="card-title font-size-32">{{ event.eventName }}</h5>
          <p class="card-text font-size-16"><img class="primary-svg" src="location-dot-solid-full.svg" width="30" height="24" alt="location"/>{{ event.eventLocation }}</p>
          <p class="card-text font-size-16"><img class="primary-svg" src="calendar-solid-full.svg" width="30" height="24" alt="calander"/>{{  getDate(event) }} <img class="primary-svg" src="clock-solid-full.svg" width="30" height="24" alt="clock"/> {{  getTime(event) }}</p>
        <div class="d-grid gap-2">
          <button [ngClass]="event.cancelled ? 'btn-secondary' : 'btn-primary'" type="button" class="btn btn-lg rounded-3 font-size-20" [routerLink]="['/event', event.id]">{{ event.cancelled ? 'Cancelled' : 'Register Now'}}</button>
        </div>
        </div>
      </div>
    </div>
    }
  </div>
</div>
